import classNames from 'classnames';
import { default as ReactSelect } from 'react-select';

import styles from './Select.module.css';
import { FormFieldError } from '../FormFieldError/FormFieldError';

const handleOnSelectChange = (value, input, onSelect) => {
    if (onSelect) return onSelect(value, input);

    return input.onChange(value.value);
};

export const SelectField = ({
    className,
    classNameSelect,
    hideError,
    input,
    label,
    meta: { touched, error },
    onSelect,
    ...selectProps
}) => (
    <div
        className={classNames(styles.SelectContainer, className)}
        data-testid={selectProps['data-testid']}
    >
        {label && <label className={styles.label}>{label}</label>}
        {touched && <FormFieldError hide={hideError} message={error} />}
        <ReactSelect
            className={classNames('SelectContainer', classNameSelect)}
            clearable={false}
            onChange={(value) => handleOnSelectChange(value, input, onSelect)}
            onBlur={() => input.onBlur(input.value)}
            value={input.value || ''}
            {...selectProps}
        />
    </div>
);
